var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconButton',{attrs:{"disabled":_vm.disabled,"iconClass":"duplicate-icon","tooltip":_vm.tooltip},on:{"btn-clicked":_vm.onButtonClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }